<div class="flex flex-wrap items-center gap-2">

    <!-- Data: input styled come pulsante cliccabile -->
    <div class="relative inline-flex items-center">
        <i class="fas fa-calendar-alt pointer-events-none absolute left-3 z-10 text-[13px] text-brand-500"></i>
        <input autocomplete="off"
               [minDate]="minDate"
               class="h-9 w-48 cursor-pointer rounded-full border border-brand-200 bg-brand-50 pl-9 pr-4 text-[13px] font-semibold text-ink shadow-sm placeholder:text-muted transition-colors hover:border-brand-400 hover:bg-brand-100 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-400"
               [placeholder]="placeholder"
               name="dp"
               (click)="dp.toggle()"
               [ngModel]="date"
               (ngModelChange)="onDateChange($event)"
               ngbDatepicker #dp="ngbDatepicker">
    </div>

    <!-- Conferma -->
    <button type="button"
            [disabled]="confirmDisabledWhenEmpty && (date == undefined)"
            (click)="confirm.emit(date)"
            class="inline-flex h-9 items-center gap-1.5 rounded-full bg-brand-600 px-4 text-[13px] font-bold text-white shadow-sm transition-all hover:bg-brand-700 active:scale-95 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-40">
        <i class="fas fa-check text-[11px]"></i> Conferma
    </button>

</div>
